/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type AttachmentEntityTypeEnum = "contacts" | "containers" | "messages" | "shipments" | "%future added value";
export type infoGeneratePoaDocumentForExternalInput = {
    clientMutationId?: string | null;
    entityType: AttachmentEntityTypeEnum;
    entitySlug: string;
    templateSlug: string;
    folderSlug: string;
    customerType?: string | null;
    language?: string | null;
    customerCountry?: string | null;
    templateLists?: Array<string> | null;
};
export type GeneratableDocItemExternalMutationVariables = {
    input: infoGeneratePoaDocumentForExternalInput;
};
export type GeneratableDocItemExternalMutationResponse = {
    readonly infoGeneratePoaDocumentForExternal: {
        readonly clientMutationId: string | null;
    } | null;
};
export type GeneratableDocItemExternalMutation = {
    readonly response: GeneratableDocItemExternalMutationResponse;
    readonly variables: GeneratableDocItemExternalMutationVariables;
};



/*
mutation GeneratableDocItemExternalMutation(
  $input: infoGeneratePoaDocumentForExternalInput!
) {
  infoGeneratePoaDocumentForExternal(input: $input) {
    clientMutationId
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "infoGeneratePoaDocumentForExternalPayload",
    "kind": "LinkedField",
    "name": "infoGeneratePoaDocumentForExternal",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "GeneratableDocItemExternalMutation",
    "selections": (v1/*: any*/),
    "type": "ApplicationCommand",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "GeneratableDocItemExternalMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "127b0cb370e09e5e6b3a1a74681f9aa2",
    "id": null,
    "metadata": {},
    "name": "GeneratableDocItemExternalMutation",
    "operationKind": "mutation",
    "text": "mutation GeneratableDocItemExternalMutation(\n  $input: infoGeneratePoaDocumentForExternalInput!\n) {\n  infoGeneratePoaDocumentForExternal(input: $input) {\n    clientMutationId\n  }\n}\n"
  }
};
})();
(node as any).hash = '08d2b57ff123321399ba48908b795539';
export default node;
